import Phaser from "phaser";
import {CardConfig, CardType, StatType} from "./CardTypes";
import {applyCardEffect} from "./CardEffect";
import {Stats} from "./Stats";

interface RoomConfig {
    type: number;
    cardConfig?: CardConfig;
    x: number;
    y: number;
}

export class Room extends Phaser.Physics.Arcade.Sprite {
    public startX: number;
    private ladderSprite?: Phaser.GameObjects.Sprite;
    private effectSprite?: Phaser.GameObjects.Sprite;
    private effectTween?: Phaser.Tweens.Tween;
    private isEffectShown: boolean = false

    constructor(scene: Phaser.Scene, private config: RoomConfig, private container: Phaser.GameObjects.Container,
                private hasLadder: boolean, private playerStats: Stats) {
        super(scene, config.x, config.y, `room`);
        scene.add.existing(this);
        scene.physics.add.existing(this);
        this.startX = config.x;
    }

    public getConfig() {
        return this.config
    }

    public showEffect(cardConfig: CardConfig, instant: boolean = false): void {
        if (this.isEffectShown) {
            return
        }

        let effectImage: string

        if (cardConfig.type === CardType.INCREASE_STAT) {
            if (cardConfig.statType === StatType.SANCTUARY) {
                effectImage = 'room_sanctuary'
            }
            else if (cardConfig.statType === StatType.FORGE) {
                effectImage = 'room_forge'
            }
            else {
                throw new Error(`Unknown stat type: ${cardConfig.statType}`)
            }
        }
        else if (cardConfig.type === CardType.CREATE_MONSTER) {
            effectImage = 'room_simple'
        }
        else {
            throw new Error(`Unknown card type: ${cardConfig.type}`)
        }

        this.effectSprite = this.scene.add.sprite(this.x, this.y, effectImage);
        this.effectSprite.setDepth(2);

        this.container.add(this.effectSprite);

        if (!instant) {
            this.effectSprite.setAlpha(0);
            this.effectTween = this.scene.tweens.add({
                targets: this.effectSprite,
                alpha: 1,
                duration: 500,
                ease: 'Linear'
            });
        }

        this.isEffectShown = true
    }

    public activateRoom(): void {
        if (this.hasLadder) {
            this.effectSprite = this.scene.add.sprite(this.x, this.y, 'room_boss');
            this.effectSprite.setDepth(2);
            this.container.add(this.effectSprite);
            this.isEffectShown = true
        }
        else {
            if (this.config.cardConfig !== undefined) {
                this.showEffect(this.config.cardConfig, true)
            }
        }
    }

    public enterRoom(): void {
        if (this.config.cardConfig !== undefined) {
            applyCardEffect(this.scene, this.config.cardConfig, this.playerStats, this)
        }
    }
} 